import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  // only tenant-admin OR if subTenantId is missing
  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const IngredientsApi = {
  // Create Ingredients
  CreateIngredients: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/ingredients`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Ingredients
  PutIngredients: (IngredientsID, data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .put(`/ingredients/${IngredientsID}`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Ingredients
  ListIngredients: (page, limit) => {
    const url = `/ingredients?page=${page}&size=${limit}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Ingredient by ID
  SingleIngredients: (ingredientsID) => {
    const url = `/ingredients/${ingredientsID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Product by ID
  SingleProducts: (productID) => {
    const url = `/ingredient/product/${productID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Ingredient by ID
  DeleteIngredients: (ingredientsID) => {
    const url = `/ingredients/${ingredientsID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .delete(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Ingredient from Recipe
  DeleteRecipeIngredients: (recipeId, ingredientsID, parentIngredientId) => {
    const url = `/recipe/${recipeId}/recipeToingredient/${ingredientsID}/ingredients/${parentIngredientId}?tenantId=${decodedToken?.tenantId}&subTenantId=${decodedToken?.subTenantId}`;
    return apiApp
      .delete(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default IngredientsApi;
